import { render, staticRenderFns } from "./TypeEstateItemStatus.vue?vue&type=template&id=2da1bb76&"
import script from "./TypeEstateItemStatus.vue?vue&type=script&lang=js&"
export * from "./TypeEstateItemStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports